import { twMerge } from "tailwind-merge"

type Props = {
  positionStyle?: React.CSSProperties
  className?: string
}

const VerticalDottedLine = ({ positionStyle, className }: Props) => {
  return (
    <div
      className={twMerge(
        "hidden pointer-events-none lg:block border-r border-dashed border-neutral-300 dark:border-neutral-800",
        className
      )}
      style={{
        width: "1px",
        zIndex: -1,
        marginTop: "-500px",
        marginBottom: "-500px",
        position: "relative",
        ...positionStyle,
      }}
    >
      <div
        className="bg-linear-to-b from-bg-default via-bg-default/0 to-bg-default"
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          height: "calc(100% - 250px)",
          width: "2px",
        }}
      />
    </div>
  )
}

export default VerticalDottedLine
